export const DEPOSIT_CANCEL_REASONS_URL = '/settings/deposit-cancel-reasons'
export const DEPOSIT_CANCEL_REASON_API = '/api/internal/deposit-cancel-reason'

export const DEPOSIT_CANCEL_REASONS_BREADCRUMBS = [
  { title: 'Настройки', path: '/settings' },
  { title: 'Причины отмены депозита', path: DEPOSIT_CANCEL_REASONS_URL },
]

/** Same rule as the backend: the code is a translation key on the payment page. */
export const CODE_PATTERN = /^[a-z0-9_]{1,64}$/
